import MeilisearchDashboard from '../../pages/meilisearch/MeilisearchDashboard.vue';

export default [
  {
    path: '/v2/admin/meilisearch/dashboard',
    name: 'admin.meilisearch.dashboard',
    component: MeilisearchDashboard,
    meta: {
      title: 'Meilisearch Dashboard',
    },
  },
];
